<template>
  <base-wrapper :loading="loading">
    <base-confirm
      :visible="visibleResult"
      icon-type="badge"
      :type="error ? 'danger' : 'success'"
      :title="`Pengiriman ${error ? 'gagal' : 'berhasil'} diterima`"
      :message="
        error
          ? errorMessage
          : `Pengiriman ${$route.params.id} berhasil diterima`
      "
      :with-cancel="false"
      confirm-text="Kembali"
      @close="onClose"
      @confirmed="onClose"
    />
    <base-modal :showing="visibleLogin" size="max-w-lg">
      <base-card
        :with-style="false"
        title="Login"
        description="Login untuk menerima pengiriman"
      >
        <form class="space-y-4 border-t pt-5" @submit.prevent="onLogin">
          <base-input
            inset
            label="Username ( Email atau ID )"
            placeholder="Username ( Email atau ID )"
            type="text"
            v-model="formLogin.email"
          />
          <base-input
            inset
            label="Password"
            placeholder="Password"
            type="password"
            v-model="formLogin.password"
          />
          <base-button type="submit" fullwidth>Login</base-button>
        </form>
      </base-card>
    </base-modal>
  </base-wrapper>
</template>

<script>
import { requestMixin } from '../../../../../mixins/request/request';
import BaseConfirm from '../../../../../components/base/BaseConfirm.vue';
import BaseModal from '../../../../../components/base/BaseModal.vue';
import { StorageService } from '../../../../../services/storage.service';
import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [requestMixin],
  components: {
    BaseConfirm,
    BaseModal,
  },
  data() {
    return {
      loadingReceive: false,
      loadingLogin: false,
      error: false,
      errorMessage: null,
      visibleResult: false,
      visibleLogin: false,
      formLogin: {
        email: null,
        password: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      loginError: 'auth/getError',
    }),
    loading() {
      return this.loadingReceive || this.loadingLogin;
    },
  },
  methods: {
    ...mapActions({
      login: 'auth/login',
    }),
    async receive() {
      this.loadingReceive = true;

      const [, err] = await this.request(
        `/api/v1/stock-movements/-actions/receive-all`,
        {
          method: 'patch',
          data: {
            code: this.$route.params.id,
          },
        }
      );

      if (err) {
        this.error = true;
        this.errorMessage = this.getRequestErrorMessage(err);
      }

      this.visibleResult = true;
      this.loadingReceive = false;
    },
    onClose() {
      window.location.href = '/';
    },
    async onLogin() {
      this.loadingLogin = true;

      const res = await this.login(this.formLogin);

      if (!res) {
        this.error = true;
        this.errorMessage = this.loginError;
      } else {
        this.visibleLogin = false;
        this.receive();
      }

      this.loadingLogin = false;
    },
  },
  created() {
    const loggedIn = StorageService.getLoginState();

    if (loggedIn) {
      this.receive();
    } else {
      this.visibleLogin = true;
    }
  },
};
</script>
